
function ProductCardLoading({ children, classes = "" }) {

	return (
		<div className={`product-card loading ${classes}`}>
			<span className="sr-only">Loading...</span>
			{children}
		</div>
	);
}
export default ProductCardLoading;